module.exports = __webpack_public_path__ + "images/rangerover63162e073775784664df06aba3cd545b.png";